import { Client } from 'nice-grpc-web';
import { GrpcClientFactoryType } from './types';
import {
  CreateProcessPoint_Request,
  CreateProcessPoint_Response,
  DeleteProcessPoint_Request,
  DeleteProcessPoint_Response,
  ListProcessPoints_Request,
  ListProcessPoints_Response,
  ProcessPointServiceDefinition,
  UpdateProcessPoint_Request,
  UpdateProcessPoint_Response,
  DeepPartial,
} from '../customer_compiled/process_point_service';

export default class ProcessPointService {
  private static instance: ProcessPointService;
  private readonly client: Client<typeof ProcessPointServiceDefinition>;

  private constructor(grpcClientFactory: GrpcClientFactoryType) {
    this.client = grpcClientFactory<typeof ProcessPointServiceDefinition>(ProcessPointServiceDefinition);
  }

  static getInstance(grpcClientFactory: GrpcClientFactoryType) {
    if (!ProcessPointService.instance) {
      ProcessPointService.instance = new ProcessPointService(grpcClientFactory);
    }

    return ProcessPointService.instance;
  }

  public list(payload: DeepPartial<ListProcessPoints_Request>): Promise<ListProcessPoints_Response> {
    const request = ListProcessPoints_Request.fromPartial(payload);
    return this.client.list(request);
  }

  public delete(payload: DeepPartial<DeleteProcessPoint_Request>): Promise<DeleteProcessPoint_Response> {
    const request = DeleteProcessPoint_Request.fromPartial(payload);
    return this.client.delete(request);
  }

  public update(payload: DeepPartial<UpdateProcessPoint_Request>): Promise<UpdateProcessPoint_Response> {
    const request = UpdateProcessPoint_Request.fromPartial(payload);
    return this.client.update(request);
  }

  public create(payload: DeepPartial<CreateProcessPoint_Request>): Promise<CreateProcessPoint_Response> {
    const request = CreateProcessPoint_Request.fromPartial(payload);
    return this.client.create(request);
  }
}
